






































import Vue from "vue";

import IconShipping from "@/components/icons/IconShipping.vue";
import IconPerson from "@/components/icons/IconPerson.vue";
import IconSuccess from "@/components/icons/IconSuccess.vue";

export default Vue.extend({
  name: "modal-title",
  components: { IconShipping, IconPerson, IconSuccess },
  props: {
    icon: {
      type: String,
      default: "person",
    },
  },
});
